import { Flex } from 'antd';
import styled from 'styled-components';

export const ModuleAssignArea = styled(Flex)`
    padding: 12px 16px;
    border: 2px solid red;
    border-radius: 6px;
`;